import React,{useEffect} from 'react'
import Timer from './Timer'
import ticket from '../Assets/ticket.png'

const Ticket = ({ activeTimer,setCall, activeT }) => {
  return (
    // <div className='wingoWrapper p-4 rounded-lg center mt-4'>
    //     <div className='ticket shadow-md shadow-green-700'>
    //         <div className='left'>
    //           <div className="cuts">
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //           </div>
    //           <div style={{ border:'1px solid black' }} className='number p-2'>
    //             <p className='text-black font-bold'>NO.2583683EMC</p>
    //           </div>
    //         </div>
    //         <div className='right flex flex-col justify-center items-center'>
    //         <div className="cuts">
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //             <div className="cut"></div>
    //           </div>
    //           <div className='flex space-x-2 p-2'>
    //             <p className='font-bold text-2xl slot-time p-1 rounded-lg text-black-600'><Timer/></p>
    //           </div>
              
    //           <div style={{ borderTop:'2px solid black' }} className='flex flex-col justify-center items-center p-2 space-x-2'>
    //             <p className='font-bold text-2xl text-black'>Win Go {activeTimer.name}</p>
    //             <p className='font-bold text-black'>Emirates Club</p>
    //           </div>
    //         </div>
    //         <div className='circles'>
    //           <div className='circle'></div>
    //           <div className='circle'></div>
    //         </div>
    //     </div>
    // </div>
    <div className='container p-2 mb-4'>
        <img src={ticket} alt='' className='image'/>
        <div className='leftnumber text-white'>
          <p className='leftwin px-1'>{activeTimer.name}</p>
          <p >2501151593</p>
        </div>
          <p className='timeremaining'>Time remaining</p>
        <div className='rightnumber text-white'>
          <p ><Timer setCall={setCall} activeT={activeT}/></p>
        </div>
      </div>
  )
}

export default Ticket